import React, { useState, useEffect, useCallback, useRef } from "react";
import "../styles/Catalog.css";

// Import sound file
import flipSound from "../assets/flipsound.mp3";

// Import images
import door1 from '../assets/111.webp';
import door2 from '../assets/225.webp';
import door3 from '../assets/454.webp';
import door4 from '../assets/672.webp';
import door5 from '../assets/783.webp';
import door6 from '../assets/889.webp';
import door7 from '../assets/908.webp';
//import door8 from "../assets/803.webp";
//import door9 from "../assets/door.avif";
//import door10 from "../assets/about1.avif";

// Catalog data
const catalogPages = [
  {
    id: 0,
    type: "title",
    title: "Guch Doors Catalog",
    subtitle: "Premium Quality Doors for Every Need",
  },
  {
    id: 1,
    image: door1,
    title: "LUXURY EMBOSED DOORS",
    description:
      "Crafted with detailed embossing, these doors combine sophistication and durability for upscale interiors.",
  },
  {
    id: 2,
    image: door2,
    title: "LUXURY LAMINATE DOORS",
    description:
      "Engineered with premium laminate finishes, these doors offer both aesthetic elegance and robust performance.",
  },
  {
    id: 3,
    image: door3,
    title: "LUXURY LOMINOUS DOORS",
    description:
      "Designed to glow and stand out, Luminous Doors bring a modern, radiant touch to contemporary homes.",
  },
  {
    id: 4,
    image: door4,
    title: "LUXURY METAL DOORS",
    description:
      "Built for maximum security with a sleek finish, our metal doors offer strength without compromising style.",
  },
  {
    id: 5,
    image: door5,
    title: "LUXURY ULTRA LAM DOORS",
    description:
      "Ultra Lam doors combine cutting-edge lamination technology with luxurious design to elevate any space.",
  },
  {
    id: 6,
    image: door6,
    title: "LUXURY VILLA DOORS",
    description:
      "Ideal for grand entrances, these villa doors are crafted to reflect timeless charm and superior craftsmanship.",
  },
  {
    id: 7,
    image: door7,
    title: "FIRE EXIT DOORS",
    description:
      "Manufactured to meet strict fire safety standards, these doors ensure safe evacuation during emergencies.",
  },
];


const Catalog = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isFlipping, setIsFlipping] = useState(false);
  const [flipDirection, setFlipDirection] = useState("");
  const [flipProgress, setFlipProgress] = useState(0);

  const flipAudio = useRef(null);
  const bookRef = useRef(null);

  const playFlipSound = () => {
    if (flipAudio.current) {
      flipAudio.current.currentTime = 0;
      flipAudio.current.play();
    }
  };

  const nextPage = useCallback(() => {
    if (currentPage < catalogPages.length - 1 && !isFlipping) {
      setIsFlipping(true);
      setFlipDirection("next");
      playFlipSound();

      // Animate the flip progress
      const startTime = Date.now();
      const duration = 800;

      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        setFlipProgress(progress);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setCurrentPage(currentPage + 1);
          setFlipProgress(0);
          setIsFlipping(false);
          setFlipDirection("");
        }
      };

      requestAnimationFrame(animate);
    }
  }, [currentPage, isFlipping]);

  const prevPage = useCallback(() => {
    if (currentPage > 0 && !isFlipping) {
      setIsFlipping(true);
      setFlipDirection("prev");
      playFlipSound();

      // Animate the flip progress
      const startTime = Date.now();
      const duration = 800;

      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        setFlipProgress(progress);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setCurrentPage(currentPage - 1);
          setFlipProgress(0);
          setIsFlipping(false);
          setFlipDirection("");
        }
      };

      requestAnimationFrame(animate);
    }
  }, [currentPage, isFlipping]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        nextPage();
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        prevPage();
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [nextPage, prevPage]);

  const goToPage = (pageIndex) => {
    if (pageIndex !== currentPage && !isFlipping) {
      const direction = pageIndex > currentPage ? "next" : "prev";
      setIsFlipping(true);
      setFlipDirection(direction);
      playFlipSound();

      const startTime = Date.now();
      const duration = 800;

      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        setFlipProgress(progress);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setCurrentPage(pageIndex);
          setFlipProgress(0);
          setIsFlipping(false);
          setFlipDirection("");
        }
      };

      requestAnimationFrame(animate);
    }
  };

  const renderPage = (page) => {
    if (page.type === "title") {
      return (
        <div className="catalog-title-page">
          <div className="title-content">
            <h1 className="catalog-main-title">{page.title}</h1>
            <p className="catalog-subtitle">{page.subtitle}</p>
            <div className="book-decoration">
              <div className="book-ornament"></div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="catalog-item">
        <div className="page-header">
          <div className="page-number">{page.id}</div>
        </div>
        <img src={page.image} alt={page.title} className="catalog-image" />
        <div className="catalog-info">
          <h3>{page.title}</h3>
          <p>{page.description}</p>
          {page.features && (
            <ul className="features-list">
              {page.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  };

  // For visible flipping page
  const flipping = isFlipping;
  const isNext = flipDirection === "next";
  const flipAngle = flipping
    ? isNext
      ? flipProgress * -180
      : (1 - flipProgress) * -180
    : 0;

  return (
    <section className="catalog">
      <audio ref={flipAudio} src={flipSound} preload="auto" />
      <div className="catalog-container">
        <div className="book-container" ref={bookRef}>
          {/* Flipping page (visible during flip) */}
          {flipping && (
            <div
              className="flipping-page"
              style={{
                zIndex: 3,
                transform: `rotateY(${flipAngle}deg)`,
              }}
            >
              {/* Front face: current page */}
              <div className="flipping-face flipping-front">
                {renderPage(catalogPages[currentPage])}
                <div
                  className="flipping-shadow"
                  style={{
                    opacity: isNext
                      ? flipProgress * 0.5
                      : (1 - flipProgress) * 0.5,
                  }}
                />
              </div>
              {/* Back face: next/prev page, mirrored */}
              <div className="flipping-face flipping-back">
                {renderPage(catalogPages[currentPage + (isNext ? 1 : -1)])}
                <div
                  className="flipping-shadow"
                  style={{
                    opacity: isNext
                      ? (1 - flipProgress) * 0.5
                      : flipProgress * 0.5,
                  }}
                />
              </div>
            </div>
          )}

          {/* Static current page (only when not flipping) */}
          {!flipping && (
            <div className="book-page current-page" style={{ zIndex: 2 }}>
              {renderPage(catalogPages[currentPage])}
            </div>
          )}

          {/* Static next/prev page (under flipping page) */}
          {flipping && (
            <div className="book-page next-page" style={{ zIndex: 1 }}>
              {renderPage(catalogPages[currentPage + (isNext ? 1 : -1)])}
            </div>
          )}

          {/* Book shadow */}
          <div className="book-shadow"></div>
        </div>

        <div className="catalog-controls">
          <button
            className="nav-btn prev-btn"
            onClick={prevPage}
            disabled={currentPage === 0 || isFlipping}
          >
            <span className="btn-icon">‹</span>
            <span className="btn-text">Previous</span>
          </button>

          <div className="page-indicators">
            {catalogPages.map((_, index) => (
              <button
                key={index}
                className={`page-dot ${index === currentPage ? "active" : ""}`}
                onClick={() => goToPage(index)}
                disabled={isFlipping}
              />
            ))}
          </div>

          <button
            className="nav-btn next-btn"
            onClick={nextPage}
            disabled={currentPage === catalogPages.length - 1 || isFlipping}
          >
            <span className="btn-text">Next</span>
            <span className="btn-icon">›</span>
          </button>
        </div>

        <div className="page-counter">
          Page {currentPage + 1} of {catalogPages.length}
        </div>
      </div>
    </section>
  );
};

export default Catalog;
